<template>
   <div class="container">
      <common-head></common-head>
      <div class="ct-index">
         <div class="inner">
            <!-- <div class="ct-banner">
               <category v-model="categoryData"></category>
               <home-swiper v-model="swiperData"></home-swiper>
            </div> -->
            <div class="m-item" v-for="(item, index) of columnData" :key="index">
               <recommend v-if="item.CSS == 1" v-model="columnData[index]"></recommend>
               <theme v-if="item.CSS == 2" v-model="columnData[index]"></theme>
               <top-book v-if="item.CSS == 3" v-model="columnData[index]"></top-book>
            </div>

         </div>
      </div>
      <common-foot></common-foot>
   </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import Category from "./components/Category";
import HomeSwiper from "./components/Swiper";
import Recommend from "./components/Recommend";
import Theme from "./components/Theme";
import TopBook from "./components/Topbook";
import { MessageBox } from 'element-ui';
export default {
   name: "Home",
   components: {
      CommonHead,
      CommonFoot,
      Category,
      HomeSwiper,
      Recommend,
      Theme,
      TopBook,
   },
   data: function () {
      return {
         //categoryData: [],
         //swiperData: [],
         columnData: [],
         demoData: [],
      };
   },
   methods: {
      loadData() {
         // this.$bti.GetColumnTypeList({ orgId: this.http.GetOrgInfo().OrgId }).then((res) => {
         //    let list = res.data.filter(p => p.PARENTID == null & p.TYPE != 0);
         //    list.forEach(element => {
         //       this.categoryData.push({ ID: element.ID, NAME: element.NAME, TYPE: element.TYPE, List: res.data.filter(p => p.PARENTID == element.ID) });
         //    });
         // });
         // this.$bti.GetADList({ ORGID: this.http.GetOrgInfo().OrgId, ISMOBILE: 2 }).then((res) => {
         //    this.swiperData = res.data;
         // });
         this.$bti.GetColumnDataList({ orgId: this.http.GetOrgInfo().OrgId }).then((res) => {
            this.columnData = res.data;
         });
      },
   },
  async mounted() {
      await this.$onWait;
      this.loadData();
   },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue